import { create } from 'zustand';

interface VotesState {
  isVotingByDuelId: Record<string, boolean>;
  setVoting: (duelId: string, isVoting: boolean) => void;
}

export const useVotesStore = create<VotesState>((set) => ({
  isVotingByDuelId: {},
  setVoting: (duelId, isVoting) => set((s) => ({ isVotingByDuelId: { ...s.isVotingByDuelId, [duelId]: isVoting } })),
}));

